"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * API V1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.StoreCreateToJSON = exports.StoreCreateFromJSONTyped = exports.StoreCreateFromJSON = exports.instanceOfStoreCreate = exports.StoreCreateStatusEnum = void 0;
var runtime_1 = require("../runtime");
/**
 * @export
 */
exports.StoreCreateStatusEnum = {
    Draft: 'draft',
    Open: 'open',
    Closed: 'closed'
};
/**
 * Check if a given object implements the StoreCreate interface.
 */
function instanceOfStoreCreate(value) {
    var isInstance = true;
    return isInstance;
}
exports.instanceOfStoreCreate = instanceOfStoreCreate;
function StoreCreateFromJSON(json) {
    return StoreCreateFromJSONTyped(json, false);
}
exports.StoreCreateFromJSON = StoreCreateFromJSON;
function StoreCreateFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'name': !(0, runtime_1.exists)(json, 'name') ? undefined : json['name'],
        'urlSlug': !(0, runtime_1.exists)(json, 'url_slug') ? undefined : json['url_slug'],
        'description': !(0, runtime_1.exists)(json, 'description') ? undefined : json['description'],
        'companyUrl': !(0, runtime_1.exists)(json, 'company_url') ? undefined : json['company_url'],
        'creatorId': !(0, runtime_1.exists)(json, 'creator_id') ? undefined : json['creator_id'],
        'contactInformation': !(0, runtime_1.exists)(json, 'contact_information') ? undefined : json['contact_information'],
        'status': !(0, runtime_1.exists)(json, 'status') ? undefined : json['status'],
    };
}
exports.StoreCreateFromJSONTyped = StoreCreateFromJSONTyped;
function StoreCreateToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'name': value.name,
        'url_slug': value.urlSlug,
        'description': value.description,
        'company_url': value.companyUrl,
        'creator_id': value.creatorId,
        'contact_information': value.contactInformation,
        'status': value.status,
    };
}
exports.StoreCreateToJSON = StoreCreateToJSON;
